import React from "react";

export const Openwatsapp = (details = null) => {
  const message = `
Hello SSK Travels 👋

 *Booking Request*

Name: ${details?.name || "-"}
Mobile: ${details?.mobile || "-"}

${details.bookingType === 'driver' ? `Customer Car: ${details?.customerCar}`: `Car : ${details.car}`}
${details.bookingType !== 'rental' ? `Pickup: ${details?.pickup || "-"}`: ''}
${details.bookingType !== 'rental' ? `Drop: ${details?.drop || "-"}` : ''}
BookingType : ${details.bookingType}

Please contact me for confirmation.
`;

  const encodedMessage = encodeURIComponent(message);

  window.open(
    `https://wa.me/919551776782?text=${encodedMessage}`,
    "_blank"
  );
};


const DirectWatsApp = () => {
const message = `
      Hello SSK Travels 👋

      *Booking Request*

      I would love to book a ride with you! 🚗✨
      Looking forward to your confirmation. 🙏

      Please contact me when possible. 📞
      Thank you! 🌟
`;

  const encodedMessage = encodeURIComponent(message);

  window.open(
    `https://wa.me/919551776782?text=${encodedMessage}`,
    "_blank"
  );
};



export default Openwatsapp;

export const ContactWatsapp = () => {
    return (
        <button
            onClick={DirectWatsApp}
            className="
                    fixed bottom-6 right-6
                    w-16 h-16 rounded-full
                    bg-green
                    shadow-lg shadow-green-500/50
                    flex items-center justify-center
                    text-white text-2xl
                    hover:scale-110 hover:shadow-2xl
                    transition-transform duration-300 z-50"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 24 24"
                className="w-8 h-8"
            >
                <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.246 3.481 5.232 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.593 5.448 0 9.887-4.434 9.889-9.883.002-2.635-1.03-5.104-2.906-6.981-1.875-1.877-4.346-2.908-6.981-2.91-5.448 0-9.887 4.434-9.889 9.882-.001 2.219.651 3.891 1.746 5.742l-.999 3.648 3.569-.956zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.148-1.758-.868-2.031-.967-.272-.099-.47-.148-.668.148-.198.297-.768.967-.941 1.164-.173.198-.347.223-.644.074-.297-.148-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.655-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.496.099-.198.05-.372-.025-.52-.075-.148-.668-1.611-.916-2.206-.242-.579-.487-.5-.668-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.077 4.487.709.306 1.261.489 1.692.626.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.29.173-1.414z" />
            </svg>
        </button>
    );
};
